import { atom } from 'recoil';
import { ShippingProvider } from '../interfaces/ShippingProvider/ShippingProvider';

export const shippingProvidersAtom = atom({
  key: 'shippingProviders',
  default: [] as ShippingProvider[],
});
